import { format, isValid, parse, parseISO } from 'date-fns';

export function formatDate(dateString: string | Date | undefined | null): string {
  if (!dateString) return 'Not specified';
  
  try {
    // Handle different date formats
    let date: Date | null = null;
    
    if (typeof dateString === 'string') {
      // Try parsing ISO format first
      date = parseISO(dateString);
      
      // If invalid, try parsing DD/MM/YYYY format
      if (!isValid(date)) {
        date = parse(dateString, 'dd/MM/yyyy', new Date());
      }
      
      // If still invalid, try parsing DD-MM-YYYY format
      if (!isValid(date)) {
        date = parse(dateString, 'dd-MM-yyyy', new Date());
      }
    } else {
      date = dateString;
    }

    if (!isValid(date)) {
      console.warn('Invalid date format:', dateString);
      return 'Not specified';
    }

    return format(date, 'dd MMM yyyy');
  } catch (error) {
    console.error('Error formatting date:', error, dateString);
    return 'Not specified';
  }
}

export function parseLeaseDate(dateString: string | undefined | null): Date | null {
  if (!dateString) return null;
  
  try {
    // Try parsing different date formats
    let date: Date | null = null;
    
    // Try ISO format first
    date = parseISO(dateString);
    
    // If invalid, try DD/MM/YYYY format
    if (!isValid(date)) {
      date = parse(dateString, 'dd/MM/yyyy', new Date());
    }
    
    // If still invalid, try DD-MM-YYYY format
    if (!isValid(date)) {
      date = parse(dateString, 'dd-MM-yyyy', new Date());
    }

    return isValid(date) ? date : null;
  } catch (error) {
    console.error('Error parsing date:', error, dateString);
    return null;
  }
}

export function isExpired(date: Date | null): boolean {
  if (!date) return false;
  return date < new Date();
}

export function isExpiringSoon(date: Date | null, days: number = 90): boolean {
  if (!date) return false;
  const today = new Date();
  const futureDate = new Date();
  futureDate.setDate(today.getDate() + days);
  return date > today && date <= futureDate;
}